module.exports = __webpack_public_path__ + "static/media/d4ru.fc8ea22c.pdf";